var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 559,
    viewBox: "0 0 545 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M367.531 478.418L356.274 463.782L306.281 398.757L245.032 478.418H367.531Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545 415.643H448.473L448.466 415.65L496.726 478.418H496.74L545 415.65V415.643Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 398.751L245.018 478.411H245.032L306.281 398.751L306.274 398.744H183.775L183.769 398.751Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.515 479.24L427.751 557.578H307.283L367.515 479.24Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2632 239.402L61.2563 239.409L122.506 319.069H122.519L183.769 239.409L183.762 239.402H61.2632Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 319.069L183.769 239.409L122.52 319.069H245.018Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 319.083L183.762 398.744H183.776L245.025 319.083L245.018 319.069H122.52L122.513 319.083Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 80.0742L122.513 159.735H245.018L183.769 80.0742Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M122.506 159.735H122.513L183.769 80.0743L183.762 80.0674H61.2563V80.0743L122.506 159.735Z",
    fill: "white",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 0.406738L61.2563 80.0672H183.762L122.513 0.406738Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 477.6L62.2662 399.244H182.759L122.513 477.6Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.506 319.076H0.00684357L0 319.083L61.2494 398.744H61.2631H183.762L122.513 319.083L122.506 319.076Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.747 238.902H61.4957L1.00985 160.234H122.261L182.747 238.902Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.268 558.078H306.275H306.268L245.025 478.417L183.776 558.078H306.254H306.268Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 159.735H245.025L306.281 80.0743L306.274 80.0674H183.769V80.0743L245.018 159.735Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M428.794 399.571L489.028 477.911H368.559L385.039 456.468L385.039 456.468L428.794 399.571Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M367.618 477.495L367.534 477.604L384.642 456.163L367.865 477.994L367.618 477.495ZM367.618 477.495L384.246 455.859L384.606 456.135L384.246 455.859L428.162 398.751L367.538 319.903L306.913 398.751L356.67 463.47L367.523 477.589L367.609 477.478L367.618 477.495ZM246.035 478.911H366.507L306.268 557.258L246.035 478.911ZM183.769 399.571L244.394 478.419L183.529 557.578H62.2783L122.764 478.911H122.766L122.916 478.716L183.769 399.571Z",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 397.932L246.029 319.569H366.533L306.281 397.932Z",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.762 398.744L183.769 398.75L183.775 398.744H183.762Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.385 226.75L352.652 200.392L372.925 226.75H332.385Z",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.646 62.6607L269.052 20.5141L301.459 62.6607H236.646Z",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 80.0674H306.274L306.281 80.0737V80.0674Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.05 478.418L490.057 478.411H490.043L490.05 478.418Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.801 398.744H428.787L428.794 398.75L428.801 398.744Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 80.0674H183.762L183.768 80.0737V80.0674Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M367.544 319.069H367.531L367.538 319.083L367.544 319.069Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.778 239.902H305.271L245.025 318.258L184.778 239.902Z",
    stroke: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M244.003 160.234L183.762 238.581L123.523 160.234H244.003Z",
    stroke: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 159.734L183.762 239.402H306.302L245.018 159.734Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183.742 558.085H183.755L244.998 478.438L244.991 478.424L244.998 478.417H122.499L122.492 478.424L183.742 558.085Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 558.085H306.302L367.537 478.438L367.531 478.424L367.537 478.417H245.045L245.039 478.424L306.281 558.085Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 159.735L306.288 80.095L306.275 80.0812L306.282 80.0674H183.79L183.783 80.0812L245.018 159.735Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M122.205 319.228H122.218L183.461 239.581L183.454 239.568L183.461 239.554H60.9619L60.9551 239.568L122.205 319.228Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M428.766 398.737L417.509 384.1L367.517 319.076L306.268 398.737H428.766Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M411.689 420.991L428.794 398.744H306.295L367.544 478.404L411.689 420.991Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.132 230.604L288.362 278.425V278.432H288.369H361.902L325.132 230.604Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 478.37L184.084 558.002H122.855V478.37Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLayer);
export default __webpack_public_path__ + "static/media/heroLayer.45e2f9668572da5add5be614d8925cf3.svg";
export { ForwardRef as ReactComponent };